import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Box,
  Typography,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import CheckIcon from "@mui/icons-material/Check";
import { useLanguage } from "../../contexts/LanguageContext";
import { useTranslation } from "react-i18next";

const LanguageSelector = ({ variant = "icon" }) => {
  const { t } = useTranslation();
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
    handleClose();
  };

  if (variant === "button") {
    return (
      <Box>
        <Tooltip title={t("language.changeLanguage")}>
          <IconButton
            onClick={handleClick}
            color="inherit"
            sx={{
              border: (theme) => `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
            }}
          >
            <LanguageIcon />
            <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
              {
                availableLanguages.find((lang) => lang.code === currentLanguage)
                  ?.nativeName
              }
            </Typography>
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {availableLanguages.map((language) => (
            <MenuItem
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              selected={currentLanguage === language.code}
            >
              <ListItemText
                primary={language.nativeName}
                secondary={language.name}
              />
              {currentLanguage === language.code && (
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <CheckIcon color="primary" />
                </ListItemIcon>
              )}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    );
  }

  // Default icon variant
  return (
    <Box>
      <Tooltip title={t("language.changeLanguage")}>
        <IconButton onClick={handleClick} color="inherit">
          <LanguageIcon color="primary" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {availableLanguages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            selected={currentLanguage === language.code}
          >
            <ListItemText
              primary={language.nativeName}
              secondary={language.name}
            />
            {currentLanguage === language.code && (
              <ListItemIcon sx={{ minWidth: 32 }}>
                <CheckIcon color="primary" />
              </ListItemIcon>
            )}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;
